import {
    Component,
    Input,
    Output,
    EventEmitter
  } from '@angular/core'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { ApiService } from 'src/app/core/services/api.service'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

  @Component({
    selector: 'web-prequal-footer',
    templateUrl: './web-prequal-footer.component.html',
    styleUrls: ['./web-prequal-footer.component.scss'],
    standalone: false
})
  export class WebAppFooterComponent {
    showFooterSecurity : boolean = false
    @Output() dataSubmited: EventEmitter<any> = new EventEmitter()

    @Input() FULL_DEV: any = false
    @Input() breakpoints: any = {
      extraSmall: false,
      small: false,
      medium: false,
      large: true,
      extraLarge: true,
    }

     constructor(
      public modalStateService: ModalStateService,
      private api: ApiService,
      public sharedDataService: SharedDataService
    ) {}

    showFooterDesc(){
      this.showFooterSecurity = true
    }

    closeFooterSecurity(){
      this.showFooterSecurity = false
    }

  }
  